import { render, staticRenderFns } from "./GameListPage.vue?vue&type=template&id=47e96893&scoped=true"
import script from "./GameListPage.vue?vue&type=script&lang=js"
export * from "./GameListPage.vue?vue&type=script&lang=js"
import style0 from "./GameListPage.vue?vue&type=style&index=0&id=47e96893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e96893",
  null
  
)

export default component.exports